export default class PolicyRules {
  constructor(client) {
    this.client = client;
    this.resourceUrl = "";
  }

  getDxLimitationList() {
    return this.client.get(`/policyRules/dxLimitationXref`);
  }
}
